<template>
  <div
    id="mywordcloud_negative"
    :style="{ width: '100%', height: '100%' }"
    :data="list_data"
  ></div>
</template>

<script>
import echarts from "echarts";
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
import { gethotSpotAnalysis3 } from "../../../../api/bot";
export default {
  name: "VueWordCloudNegative",
   props:['NEGATIVE'],
  data() {
    return {
      NEGATIVE: [],
      list_data: [], 
    };
  },
  watch:{
     NEGATIVE(){
    this.initChart();
     },
      deep: true
 },
  mounted() {
     this.initChart();
   
  },
  methods: {
    initChart() {     
        let arr = this.NEGATIVE;
        let arrObj = { ...arr };
        function convertToArray(objct) {
          return Object.keys(objct).map((key) => ({
            name: arrObj[key],
            value: key,
          }));
        }
        this.list_data = convertToArray(arrObj);
        const option = {
          title: {
            text: "负面关键词",
            x: "10%",
          },
          backgroundColor: "",
          // tooltip: {
          //   pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
          // },
          series: [
            {
              type: "wordCloud",
              //用来调整词之间的距离
              gridSize: 10,
              //用来调整字的大小范围
              // Text size range which the value in data will be mapped to.
              // Default to have minimum 12px and maximum 60px size.
              sizeRange: [14, 40],
              // Text rotation range and step in degree. Text will be rotated randomly in range [-90,                                                                             90] by rotationStep 45
              //用来调整词的旋转方向，，[0,0]--代表着没有角度，也就是词为水平方向，需要设置角度参考注释内容
              // rotationRange: [-45, 0, 45, 90],
              // rotationRange: [ 0,90],
              rotationRange: [0, 0],
              //随机生成字体颜色
              // maskImage: maskImage,
              textStyle: {
                normal: {
                  color: function() {
                    return (
                      "rgb(" +
                      Math.round(Math.random() * 255) +
                      ", " +
                      Math.round(Math.random() * 255) +
                      ", " +
                      Math.round(Math.random() * 255) +
                      ")"
                    );
                  },
                },
              },
              //位置相关设置
              // Folllowing left/top/width/height/right/bottom are used for positioning the word cloud
              // Default to be put in the center and has 75% x 80% size.
              left: "left",
              top: "center",
              right: null,
              bottom: null,
              width: "100%",
              height: "100%",
              //数据
              data: this.list_data,
            },
          ],
        };
        //初始化echarts实例
        var myChart = echarts.init(
          document.getElementById("mywordcloud_negative")
        );
        //使用制定的配置项和数据显示图表
        myChart.setOption(option);
        window.onresize = function() {
          myChart.resize();
        };
    },
  },
};
</script>
